import React, { useState, useEffect } from "react";
import StickyMenu from "../../components/common/StickyMenu";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import SettingsPanel from "../shared/SettingsPanel";
import Sidebar from "../shared/Sidebar";
import { useMemo } from "react";
import DataTable from "react-data-table-component";
import { Container, Row, Col, Button, Form, Card, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import UserService from "../../services/UserService";
import FilterDataTable from "../../pages/instructor/FilterDataTable";
import adminServices from "../../services/adminServices";
import learnerService from "../../services/learnerService";
import service, { URI } from "../../services/service";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { downloadExcel } from 'react-export-table-to-excel';

const languages = [
  {
    code: "en",
    name: "English",
    country_code: "gb",
  },
];

const customStyles = {
  title: {
    style: {
      fontColor: "red",
      fontWeight: "900",
    },
  },
  headCells: {
    style: {
      fontSize: "17px",
      fontWeight: "500",
      paddingLeft: "0 8px",
      marginLeft: "10px",
    },
  },
  cells: {
    style: {
      fontSize: "15px",
      // paddingLeft: '0 8px',
      // marginLeft: '10px'
    },
  },
};

function NFSUTemplateReport() {
  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  const { t } = useTranslation();

  useEffect(() => {
    document.body.dir = currentLanguage.dir || "ltr";
    document.title = t("app_title");
  }, [currentLanguage, t]);

  useEffect(() => {
    UserService.generateToken();
  }, []);

  const history = useHistory();

  const um_api = URI.SERVER?._USER_API;

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterDataTable
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const [reportLoading, setReportLoading] = useState({
    isLoading: false,
  });

  const returnAcademicYear = (inputDate) => {

    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // JS month is 0-based

    let startYear;

    // If April (4) or later → same year financial start
    if (month >= 4) {
      startYear = year;
    } else {
      startYear = year - 1;
    }

    const endYear = startYear + 1;

    // Convert to YY-YY format
    const fy = `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;

    return fy;

  }


  const columns = [
    {
      name: "SNo",
      selector: (row) => `${row.sno}`,
      sortable: true,
      wrap: true,
      width: "80px"
    },
    {
      name: "Name",
      selector: (row) => `${row.title} ${row.firstName} ${row.lastName}`,
      sortable: true,
      wrap: true,
      width: "200px"
    },
    {
      name: "Gender",
      selector: (row) => row.gender,
      sortable: true,
      width: "100px"
    },
    {
      name: "Email",
      selector: (row) => row.email,
      wrap: true,
      sortable: true,
      width: "250px"
    },
    {
      name: "Mobile",
      selector: (row) => row.mobile,
      sortable: true,
    },
    {
      name: "Date Of Birth",
      selector: (row) => row.dob,
      wrap: true,
      sortable: true,
    },
    {
      name: "Qualification",
      selector: (row) => row.eduQualification,
      wrap: true,
      sortable: true,
    },
    {
      name: "Institute",
      selector: (row) => row.instituteName,
      wrap: true,
      sortable: true,
    },
    {
      name: "Registered Date",
      selector: (row) => moment(row.registeredDate).format('MM-DD-YYYY HH:mm'),
      wrap: true,
      sortable: true,
    },
    {
      name: "Country",
      selector: (row) => { return row.countryId == 1 ? row.countryName : row.otherCountryName },
      wrap: true,
      sortable: true,
    },
    {
      name: "State/City",
      selector: (row) => { return row.stateId == 0 ? <>City - {row.city}</> : <>State - {row.stateName}<br />City - {row.city}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Course Name",
      selector: (row) => { return row.courseId == null ? <> </> : <>{row.courseName}</> },
      wrap: true,
      sortable: true,
      width: "300px"
    },
    {
      name: "Course Enrollment Request Date",
      selector: (row) => { return row.courseEnrollReqDate == null ? <> </> : <>{moment(row.courseEnrollReqDate).format('MM-DD-YYYY HH:mm')}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Course Enrollment Approve Date",
      selector: (row) => { return row.courseEnrollApprovRejecDate == null ? <> </> : <>{moment(row.courseEnrollApprovRejecDate).format('MM-DD-YYYY HH:mm')}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Course Payment OrderId",
      selector: (row) => { return row.orderId == null ? <> </> : <>{row.orderId}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => { return row.amount == null ? <> </> : <>{row.amount}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Transaction Date",
      selector: (row) => { return row.transactionDate == null ? <> </> : <>{moment(row.transactionDate).format('MM-DD-YYYY HH:mm')}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Progress Status",
      selector: (row) => { return row.progressStatus == null ? <> </> : <>{row.progressStatus}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Certificate Download Status",
      selector: (row) => { return row.certificateDownloadStatus == null ? <> </> : <>{row.certificateDownloadStatus}</> },
      wrap: true,
      sortable: true,
    },
    {
      name: "Course Year",
      selector: (row) => {
        if (!row.lastAccessed) return <> </>;
        return <>{returnAcademicYear(row.lastAccessed)}</>;
      },
      wrap: true,
      sortable: true,
    },
    {
      name: "Academic Year",
      selector: (row) => {
        if (!row.registeredDate) return <> </>;
        return <>{returnAcademicYear(row.registeredDate)}</>;
      },
      wrap: true,
      sortable: true,
    }
  ];

  const [getLearnerData, setlearnerData] = useState([]);
  useEffect(() => {
    LearnersDatas();
  }, []);

  const LearnersDatas = () => {
    adminServices
      .getAllLearnersDataForNFSUReport()
      .then((resp) => {
        setlearnerData(resp.data);
      })
      .catch((err) => { });
  };

  const filteredItems = getLearnerData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );

  const exportExcel = () => {

    var checkData = [];
    const header = ["SNo", "Name", "Gender", "Email", "Mobile", "Date Of Birth", "Qualification", "Institute", "Registered Date", "Country", "State/City", "Course Name", "Course Enrollment Request Date", "Course Enrollment Approve Date", "Course Payment OrderId", "Amount", "Transaction Date", "Progress Status", "Certificate Download Status", "Course Year", "Academic Year"]
    getLearnerData.map((row) => {
      const sno = `${row.sno}`
      const name = `${row.title} ${row.firstName} ${row.lastName}`
      const gender = `${row.gender}`
      const email = `${row.email}`
      const mobile = `${row.mobile}, ${row.mobile1} `
      const dob = `${row.dob}`
      const eduQualification = `${row.eduQualification}`
      const instituteName = `${row.instituteName}`
      const registeredDate = `${moment(row.registeredDate).format('MM-DD-YYYY HH:mm')}`
      const country = row.countryId == 1 ? `${row.countryName}` : `${row.otherCountryName}`
      const state = row.stateId == 0 ? `City - ${row.city}` : `State - ${row.stateName} , City - ${row.city}`
      const courseName = row.courseId == null ? ` ` : `${row.courseName}`
      const courseEnrollReqDate = row.courseEnrollReqDate == null ? ` ` : `${moment(row.courseEnrollReqDate).format('MM-DD-YYYY HH:mm')}`
      const courseEnrollApprovRejecDate = row.courseEnrollApprovRejecDate == null ? ` ` : `${moment(row.courseEnrollApprovRejecDate).format('MM-DD-YYYY HH:mm')}`
      const orderId = row.orderId == null ? ` ` : `${row.orderId}`
      const amount = row.amount == null ? ` ` : `${row.amount}`
      const transactionDate = row.transactionDate == null ? ` ` : `${moment(row.transactionDate).format('MM-DD-YYYY HH:mm')}`
      const progressStatus = row.progressStatus == null ? ` ` : `${row.progressStatus}`
      const certificateDownloadStatus = row.certificateDownloadStatus == null ? ` ` : `${row.certificateDownloadStatus}`
      const courseYear = row.lastAccessed == null? "": `${returnAcademicYear(row.lastAccessed)}`
      const academicYear = row.registeredDate == null? "": `${returnAcademicYear(row.registeredDate)}`

      const instData = [sno, name, gender, email, mobile, dob, eduQualification, instituteName, registeredDate, country, state, courseName, courseEnrollReqDate, courseEnrollApprovRejecDate, orderId, amount, transactionDate, progressStatus, certificateDownloadStatus, courseYear,academicYear ]
      // const instData = [imgdata,name, email, dob, mobile, eduQualification, idproofNumber, instituteName, designation, address]
      checkData.push(instData);
    })
    downloadExcel({
      fileName: "Template Report",
      sheet: "Userlist",
      tablePayload: {
        header,
        body: checkData,
      },
    })

  }

  return (
    <div className="container-scroller">
      <Navbar />
      {/* <StickyMenu /> */}
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div>
              <div className="page-header">
                <h3 className="page-title">Learners Report</h3>
              </div>
              <Col lg="12">
                <div className="card">
                  <div className="card-body">
                    <div>
                      <Button size='lg'
                        className='submit-button mr-2 btn-success' // Add margin-right for spacing
                        onClick={exportExcel}
                        disabled={reportLoading.isLoading ? "true" : ""}
                      >Download Excel Report{reportLoading.isLoading ? <><i class="fa fa-spinner" aria-hidden="true"></i></> : <></>}
                      </Button>
                    </div>
                    <div style={{ padding: "10px" }}>
                      <DataTable
                        columns={columns}
                        data={filteredItems}
                        defaultSortField="SNo"
                        defaultSortAsc={true}
                        striped
                        pagination
                        highlightOnHover
                        customStyles={customStyles}
                        subHeader
                        subHeaderComponent={subHeaderComponent}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </div>
            <SettingsPanel />
          </div>
          <Footer />
        </div>
      </div>

    </div>
  );
}

export default NFSUTemplateReport;
